import React from 'react';
import { useNavigate } from 'react-router-dom';
import TutorialPage from './TutorialPage';

const TutorialPageWrapper = () => {
  const navigate = useNavigate();
  
  // Phase 4: Navigation Integration - UNCOMMENTED
  return <TutorialPage navigate={navigate} />;
  
  // Phase 1: Basic wrapper without navigation - COMMENTED OUT
  // return <TutorialPage />;
};

export default TutorialPageWrapper;
